<template>
  <div id="mapModal" style="width: 100%; height: 100vh">
    <button class="FullScreen" @click="close">
      <font-awesome-icon icon="expand" />
    </button>
  </div>
</template>

<script>
import L from "leaflet";
export default {
  props: {
    lng: {
      type: Number,
      required: true,
      default: -74.5,
    },
    lat: {
      type: Number,
      required: true,
      default: 40,
    },
    zoom: {
      type: Number,
      required: true,
      default: 9,
    },
  },
  data: () => ({
    loading: true,
  }),
  watch: {
    loading(val) {
      if (!val) {
        this.renderModal();
      }
    },
  },
  methods: {
    renderModal() {
      var satellite = L.tileLayer(
          "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
          {
            id: "mapbox/satellite-v9",
            tileSize: 512,
            zoomOffset: -1,
            attribution:
              'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            accessToken:
              "pk.eyJ1IjoiZXN0ZWJhbmpzIiwiYSI6ImNrZWhjNWF0eDE1Yncyc3BxcG45MmJpc2QifQ.0qKtoStiG_6OtK9XyqDllQ",
          }
        ),
        streets = L.tileLayer(
          "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
          {
            id: "mapbox/streets-v11",
            tileSize: 512,
            zoomOffset: -1,
            attribution:
              'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            accessToken:
              "pk.eyJ1IjoiZXN0ZWJhbmpzIiwiYSI6ImNrZWhjNWF0eDE1Yncyc3BxcG45MmJpc2QifQ.0qKtoStiG_6OtK9XyqDllQ",
          }
        );

      L.GridLayer.DebugCoords = L.GridLayer.extend({
        createTile: function (coords) {
          var tile = document.createElement("div");
          tile.innerHTML = [coords.x, coords.y, coords.z].join(", ");
          tile.style.outline = "1px solid red";
          return tile;
        },
      });

      L.gridLayer.debugCoords = function (opts) {
        return new L.GridLayer.DebugCoords(opts);
      };

      // mymap.addLayer(L.gridLayer.debugCoords());
      var grid = L.gridLayer.debugCoords();

      var mymap = L.map("mapModal", {
        center: [this.lat, this.lng],
        zoom: this.zoom,
        layers: [satellite, grid],
      });

      var baseMaps = {
        Satellite: satellite,
        Streets: streets,
      };

      var overlayMaps = {
        Grid: grid,
      };

      L.control.layers(baseMaps, overlayMaps).addTo(mymap);

      var greenIcon = L.icon({
        iconUrl: require("../../assets/iconoMapa.png"),
        // shadowUrl: "leaf-shadow.png",

        iconSize: [60, 60], // size of the icon
        // shadowSize: [50, 64], // size of the shadow
        iconAnchor: [30, 58], // point of the icon which will correspond to marker's location
        // shadowAnchor: [4, 62], // the same for the shadow
        popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
      });

      L.marker([this.lat, this.lng], { icon: greenIcon }).addTo(mymap);
    },
    close() {
      this.$emit("callback");
    },
  },
  mounted() {
    setTimeout(() => (this.loading = false), 100);
  },
};
</script>

<style>
#mapModal {
  position: relative;
}
#mapModal .FullScreen {
  font-size: 20px;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 80px;
  left: 12px;
  z-index: 800;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>